import React from 'react';
import Icon from "./icon";

const Alert = ({size, icon, variant, styles, message, className, docsPath}) => {
    return (
        <div className={`alert-component ${size ? size : 'md'}`}>
            <div className={`alert alert-outline d-flex align-items-center alert-${variant ? variant : 'primary'} ${className ? className : ''}`} role="alert" style={styles}>
                <Icon name={icon}/>
                <div className="alert-text">
                    {message}
                </div>
            </div>
        </div>
    )
}

export default Alert;